<template>
  <v-dialog v-model="showModal" width="400" @click:outside="closeDialog">
    <v-card max-width="400">
      <v-card-title class="d-flex justify-space-between align-center">
        <div class="text-h5 text-medium-emphasis ps-2 title-text">{{ isEdit ? 'edit watchlist item' : 'add to watchlist' }}</div>
        <v-btn icon="mdi-close" variant="text" @click="closeDialog"></v-btn>
      </v-card-title>
      <v-divider class="mb-4"></v-divider>
      <v-card-text>
        <v-sheet class="mx-auto" width="300">
          <v-form @submit.prevent ref="form">
            <v-text-field v-model="ticker" id="ticker" :rules="[required]" label="ticker" variant="underlined" class="form_field" :disabled="isEdit"></v-text-field>
            <v-text-field v-model="alert_above" id="alert_above" :rules="[numericOrEmpty]" label="alert above (optional)" variant="underlined" class="form_field"></v-text-field>
            <v-text-field v-model="alert_below" id="alert_below" :rules="[numericOrEmpty]" label="alert below (optional)" variant="underlined" class="form_field"></v-text-field>
            <v-checkbox v-if="isEdit" v-model="alert_active" label="alert active" density="compact"></v-checkbox>
          </v-form>
        </v-sheet>
      </v-card-text>
      <template v-slot:actions>
        <v-btn v-on:click="submitForm" class="mt-2 submit_button" type="submit" block>Submit</v-btn>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations } from 'vuex';

export default {
  props: {
    show: Boolean,
    editItem: Object
  },
  data() {
    return {
      ticker: '',
      alert_above: '',
      alert_below: '',
      alert_active: true
    }
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    showModal: {
      get() {
        return this.show;
      }
    },
    isEdit() {
      return this.editItem !== null && this.editItem !== undefined;
    }
  },
  watch: {
    show(val) {
      if (val && this.editItem) {
        this.ticker = this.editItem.ticker;
        this.alert_above = this.editItem.alert_above != null ? parseFloat(this.editItem.alert_above) : '';
        this.alert_below = this.editItem.alert_below != null ? parseFloat(this.editItem.alert_below) : '';
        this.alert_active = !!this.editItem.alert_active;
      } else if (val) {
        this.resetDataValues();
      }
    }
  },
  methods: {
    ...mapMutations(["showSnackbar"]),
    required(v) {
      return (v !== null && v !== undefined && v !== '') || 'required';
    },
    numericOrEmpty(v) {
      return v === '' || v === null || !isNaN(v) || 'must be a number';
    },
    async submitForm(e) {
      e.preventDefault();
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;
      try {
        if (this.isEdit) {
          await axios.put(`/securities/watchlist/${this.editItem.id}`, {
            alert_above: this.alert_above !== '' ? this.alert_above : null,
            alert_below: this.alert_below !== '' ? this.alert_below : null,
            alert_active: this.alert_active
          });
        } else {
          await axios.post('/securities/watchlist/', {
            ticker: this.ticker,
            alert_above: this.alert_above !== '' ? this.alert_above : null,
            alert_below: this.alert_below !== '' ? this.alert_below : null
          });
        }
        this.resetDataValues();
        this.$emit("close");
      } catch (error) {
        this.showSnackbar({ message: this.isEdit ? 'Failed to update watchlist item' : 'Failed to add to watchlist' });
      }
    },
    closeDialog() {
      this.resetDataValues();
      this.$emit('close');
    },
    resetDataValues() {
      this.ticker = '';
      this.alert_above = '';
      this.alert_below = '';
      this.alert_active = true;
    }
  }
};
</script>

<style scoped>

.title-text, .body-text, .form_field, .submit_button {
  font-family: "Space Grotesk", "Courier New", Courier, monospace, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

</style>
